/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosRichText, CosmosText, tokenToGradientId } from "@components/elements";
import EdsIconGradient from "@components/elements/atoms/eds-icon/EdsIcon.gradient";
import { CosmosQuoteFragment } from "@cosmos/hygraph-schema";
import { css } from "@panda/css";
import { VStack } from "@panda/jsx";
import React from "react";

export const Quote = ({ quote, source, description }: CosmosQuoteFragment): React.JSX.Element | null => {
	if (!quote) return null;

	return (
		<VStack alignItems="start" gap="eds.dimension.48">
			<EdsIconGradient token="blue" />
			<svg
				className={css({ smDown: { width: "49px", height: "35px" } })}
				xmlns="http://www.w3.org/2000/svg"
				width="70"
				height="50"
				viewBox="0 0 70 50"
				fill="none"
			>
				<path
					d="M0 50L14.9259 0H31.6078L24.5838 50H0ZM38.3922 50L53.3181 0H70L62.9761 50H38.3922Z"
					fill={`url(#${tokenToGradientId("blue")})`}
				/>
			</svg>
			<CosmosRichText
				variant="heading2XL"
				className={css({ smDown: { textStyle: "headingXL" } })}
				color="eds.text.primary"
				html={quote}
			/>
			<VStack alignItems="start" gap="eds.dimension.16">
				{source ? <CosmosText variant="eyebrowMD" text={source} /> : null}
				{description ? <CosmosRichText variant="paragraphMD" color="eds.text.secondary" html={description} /> : null}
			</VStack>
		</VStack>
	);
};
